import { Injectable } from '@angular/core';
import { FilterTypes } from '@models/filterEnums.model';
import { TreeNode } from 'primeng/api';
import * as Constants from '@shared/_constants';
import { LoggingService } from '@services/logging.service';
import { ReplaySubject } from 'rxjs';
import { delay } from 'rxjs/operators';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class FilterUtilService {
  public spinnerRS = new ReplaySubject<boolean>(1);
  public spinnerVisible$ = this.spinnerRS.asObservable().pipe(delay(1));

  constructor(private logger: LoggingService) {
    this.spinnerRS.next(false);
  }

  public findNodeRecursive(id: FilterTypes, nodes: TreeNode[]) {
    this.logger.info(this.constructor.name, Constants.LoggerMessages.LOGGER_FINDNODERECURSIVE, Constants.LoggerMessages.LOGGER_START);
    let i, currentNode, result;

    if (_.isEmpty(nodes)) {
      return false;
    }

    for (i = 0; i < nodes.length; i += 1) {
      currentNode = nodes[i];
      if (id === currentNode.data) {
        return currentNode;
      } else {
        if (currentNode.children) {
          result = this.findNodeRecursive(id, currentNode.children);

          if (result !== false) {
            return result;
          }
        }
      }
    }
    return false;
  }

  public flattenTree(nodes: TreeNode[]): TreeNode[] {
    this.logger.info(this.constructor.name, Constants.LoggerMessages.LOGGER_FLATTENTREE, Constants.LoggerMessages.LOGGER_START);
    let flatNodes: TreeNode[] = [];
    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];
      flatNodes.push(node);
      if (node.children && node.children.length > 0) {
        flatNodes = flatNodes.concat(this.flattenTree(node.children));
      }
    }
    return flatNodes;
  }

  public sortSelection(selection: TreeNode[], sortIntegerValues = false): void {
    selection.sort((a, b) => {
      const textA = a.label.toString().toUpperCase();
      const textB = b.label.toString().toUpperCase();
      if (a[Constants.AddFilterDialogMessages.DISPLAY_ORDER_PROP_NAME]) {
        return a[Constants.AddFilterDialogMessages.DISPLAY_ORDER_PROP_NAME] > b[Constants.AddFilterDialogMessages.DISPLAY_ORDER_PROP_NAME] ? 1 : -1;
      } else {
        if (sortIntegerValues) {
          const intergerA: number = parseInt(textA);
          const intergerB: number = parseInt(textB);
          return intergerB > intergerA ? 1 : -1;
        }

        return textA < textB ? -1 : textA > textB ? 1 : 0;
      }
    });
  }

  public checkEndGreaterThanBeginning(beginning: string, ending: string): boolean {
    if (beginning && ending) {
      const begin: number = parseInt(beginning, 10);
      const end: number = parseInt(ending, 10);
      if (isNaN(begin) || isNaN(end)) {
        return true;
      }
      if (begin > 0 && end > 0) {
        return begin <= end;
      }
    }
    return true;
  }
}
